import { each, isEqual, omitBy } from 'lodash';
import { parse, stringify } from 'query-string';

import { toBool } from 'core/util/strings';

export interface Serializer<T> {
    serialize: (request: T, includeDefaults?: boolean) => string;
    deserialize: (str: string) => Partial<T>;
}

export enum Deserializer {
    Bool,
    Int,
}

export type Config<T> = {
    [K in keyof T]?: Deserializer;
};

export const makeQueryStringSerializer = <T extends object>(
    defaults: Partial<T> = {},
    config?: Config<T>,
): Serializer<T> => ({
    serialize: (request: T, includeDefaults?: boolean): string => {
        let preparedRequest: Partial<T> = request;
        if (!includeDefaults) {
            preparedRequest = omitBy(request, (value, key) => {
                return isEqual(value, defaults[key]) || (typeof value === 'string' && value === '');
            });
        }
        return stringify(preparedRequest, { arrayFormat: 'index' });
    },

    deserialize: (str: string) => {
        const request = { ...(defaults as {}), ...parse(str, { arrayFormat: 'index' }) };
        each(config, (deserializer, key) => {
            const value = request[key];
            if (typeof value !== 'string') {
                return;
            }
            switch (deserializer) {
                case Deserializer.Bool:
                    request[key] = toBool(value);
                    break;
                case Deserializer.Int:
                    request[key] = parseInt(value, 10);
                    break;
            }
        });
        return request;
    },
});
